<div>
    <ppl-accordion [title]="'Prospective Consumer Information'" [isOpen]="true"
        *authorize="[pageId, tabId, tabId, 'section']">
        <ppl-prospective-info [gridData]="filledInfo" [sectionData]="steps" [entry]="entry" [selectedLead]="selectedLead" [program]="program" (leadUpdated)="updatedLeadData($event)"></ppl-prospective-info>
    </ppl-accordion>
</div>